const initial = {
  size_error: '',
  quickview_size_error: ''
};

export default function Popup(state = initial, action) {
  switch (action.type) {
    case 'SELECT_SIZE_ERROR_MESSAGE':
      return {
        ...state,
        size_error: action.size_error
      };
      
      case 'SELECT_NOTIFY_MESSAGE':
        return {
          ...state,
          size_error: action.size_error
        };

    case 'QUICKVIEW_SELECT_SIZE_ERROR_MESSAGE':
      return {
        ...state,
        quickview_size_error: action.size_error
      };

    case 'RESET_QC_ERROR':
      return {
        ...state,
        quickview_size_error: ''
      };

    default:
      return state;
  }
}
